import React, { useState } from 'react'
import { trackPromise } from 'react-promise-tracker'

import ManageClient from '../../components/ManageClient'
import { SaveClient } from 'store/ClientsApiClient'
import ManageClientSidebar from '../../components/ManageClientSidebar'
import { MainContent } from '../../../../layouts/components/Structure'
import IpsaSidebar from '../../../../layouts/IpsaSidebar'
import LoadingWrapper from 'components/LoadingWrapper'
import { InitialForm } from '../../../../variables/InitialValues'

const NewClient = ({ history }) => {
    const PromiseArea = 'client-save'
    const [error, setError] = useState(null)
    const [client, setClient] = useState(InitialForm)

    const saveClient = (values, earlySave = false) => {
        trackPromise(
            SaveClient(values)
                .then((res) => {
                    if (res.data > 0) {
                        if (earlySave) {
                            const path = window.location.pathname
                            const redirectPath = path.replace('/new/', `/${res.data}/`)
                            if (redirectPath) {
                                history.push(redirectPath)
                            } else {
                                history.push(`/clients/${res.data}`)
                            }
                        } else {
                            history.push(`/clients/${res.data}/presentation/income`)
                        }
                    } else {
                        history.push(`/clients`)
                    }
                })
                .catch((err) => {
                    setClient(client)
                    setError(err)
                })
                .finally(() => {}),
            PromiseArea
        )
    }

    return (
        <>
            <IpsaSidebar>
                <ManageClientSidebar />
            </IpsaSidebar>
            <MainContent>
                <div className="col-section col-no-margin">
                    <div className="col-xs-6">
                        <h1>New Client</h1>
                    </div>
                </div>
                <LoadingWrapper area={PromiseArea}>
                    <ManageClient
                        clientId={null}
                        formState={client}
                        onSave={(values) => {
                            saveClient(values, true)
                        }}
                        onSubmit={(values) => {
                            saveClient(values)
                        }}
                    ></ManageClient>
                    {error && <p className="error">{error}</p>}
                </LoadingWrapper>
            </MainContent>
        </>
    )
}

export default NewClient
